export default __webpack_public_path__ + "static/media/Info.5f17bc35.svg";